import { cn } from '@playbooks/ui/lib/utils'
import PinnedSections from './PinnedSections'
import SlidesContainer from './SlidesContainer'
import { SectionData, ViewMode } from '@playbooks/action-cards-utils/src'
import { SplitViewPosition } from '../types'
import { Scope } from '../utils/makeSeparatorScopes'

export default function ActionCardsSections({
  splitViewPosition,
  viewMode = ViewMode.DEFAULT,
  isSplitViewEnabled = false,
  visiblePinnedSections,
  scopes,
  hideScore,
  lastSlideHtml,
}: {
  splitViewPosition: SplitViewPosition
  viewMode: ViewMode | undefined
  isSplitViewEnabled: boolean | undefined
  visiblePinnedSections: SectionData[]
  scopes: Scope[]
  hideScore: boolean
  lastSlideHtml: string | null | undefined
}) {
  const isRightSplit = splitViewPosition === 'left'
  const isFunnelView = viewMode === ViewMode.FUNNEL
  const isSplitView = isSplitViewEnabled && !isFunnelView
  const pinnedSectionsRightEnabled = isRightSplit && isSplitView
  const pinnedSectionsLeftEnabled = !isRightSplit && isSplitView

  return (
    <div data-role="data-action-cards-container" className={cn('relative flex w-full h-full gap-2')}>
      <PinnedSections sections={visiblePinnedSections} enabled={!!pinnedSectionsLeftEnabled} isRight={isRightSplit} />

      <SlidesContainer
        hideScore={!!hideScore}
        isFunnelView={isFunnelView}
        scopes={scopes}
        lastSlideHtml={lastSlideHtml}
      />

      <PinnedSections sections={visiblePinnedSections} enabled={!!pinnedSectionsRightEnabled} isRight={isRightSplit} />
    </div>
  )
}
